import * as Yup from 'yup';

const promoCodeSchema = Yup.object().shape({
  code: Yup.string().required('Code is required.'),
  startDate: Yup.date()
    .typeError('Must be a valid Date')
    .required('Start Date is required.'),
  endDate: Yup.date()
    .typeError('Must be a valid Date')
    .required('End Date is required.'),
  minimumPurchaseAmount: Yup.number()
    .required("Minimum Purchase Amount is required.")
    .typeError("Must be Number"),
  maximumDiscountAmount: Yup.number()
    .required("Maximum Purchase Amount is required.")
    .typeError("Must be Number"),
});

export default promoCodeSchema;